import CharlesButton from "components/base/Button";
import { useModals } from "ModalProvider";
import ContainerForm from "./ContainerForm";
import ContainerView from "./ContainerView";

const PackagingView = ({ pkg, deletePkg, updatePkg }) => {
  const modal = useModals();

  function createContainer(parentId) {
    modal.present({
      title: "Create Container",
      children: (
        <ContainerForm
          parentId={parentId}
          onCreate={(container) => {
            updatePkg({
              containers: [...(pkg.containers || []), container],
            });
            modal.hide();
          }}
        />
      ),
    });
  }

  const containers = pkg.containers?.filter((c) => !c.parentId) || [];

  return (
    <div>
      <div className="flex justify-between items-center">
        <h5>{pkg.name}</h5>

        <div className="flex space-x-4">
          <CharlesButton onClick={() => createContainer()}>
            + Container
          </CharlesButton>
          <CharlesButton danger onClick={deletePkg}>
            Delete Packaging
          </CharlesButton>
        </div>
      </div>

      {containers.length > 0 && (
        <div className="space-y-4 mt-4">
          {containers.map((i) => (
            <ContainerView
              key={i.id}
              container={i}
              pkg={pkg}
              updatePkg={updatePkg}
              createContainer={createContainer}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default PackagingView;
